<template>
  <div class="my-prize-container">
    <div
      :style="{ backgroundImage: 'url(' + prizeInfo.my_prize_pic_url + ')' }"
      class="prize-icon"
      @click="$emit('show-pop')"
    >
      <div v-if="+num" class="prize-num">{{ num }}</div>
    </div>
    <div class="text">我的奖品</div>
  </div>
</template>
<script>
export default {
  // props: ['num', 'prizeInfo'],
  props: {
    num: {
      type: Number,
      default: 1,
    },
    prizeInfo: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<style lang="less" scoped>
.my-prize-container {
  z-index: 3;
  .prize-icon {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-image: url(../assets/my-prize-pink.png);
    width: 72px;
    height: 72px;
    margin: 0 auto;
    position: relative;
    .prize-num {
      position: absolute;
      width: 26px;
      height: 26px;
      border-radius: 50%;
      border: 3px #fff solid;
      background-color: #ff0000;
      text-align: center;
      line-height: 26px;
      font-size: 20px;
      color: #ffffff;
      font-family: Arial-BoldMT;
      right: -14px;
      top: 2px;
    }
  }
  .text {
    font-size: 22px;
    color: #ffffff;
    text-align: center;
    padding-top: 1px;
  }
}
</style>
